<template>
  <section id="admin-filter">
    <h4>Financial Code filter</h4>
    <div class="form-group">
      <label for="fin-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="fin-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="fin-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="fin-name" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'FinancialCodeFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          code: '',
          name: '',
          category: ''
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/FinancialCode/FinancialCodeFilter.vue